module.exports = __webpack_public_path__ + "img/antes_despues_168.03a1d139.png";